import { useNavigate } from "react-router-dom";
import { FaUtensils } from "react-icons/fa";
import "./Welcome.css";

function Welcome() {

  const navigate = useNavigate();

  return (

    <div className="welcome-page">

      <div className="background-circle circle1"></div>
      <div className="background-circle circle2"></div>

      <div className="welcome-card">

        <div className="logo-circle">
          <FaUtensils />
        </div>

        <h1 className="welcome-title">
          HomeFoods
        </h1>

        <p className="welcome-tagline">
          Homemade Food • Trusted Chefs • Fast Delivery
        </p>

        <p className="welcome-description">
          Fresh homemade meals prepared by trusted home chefs,
          restaurants, hotels, bakeries and catering services,
          delivered with quality and care.
        </p>

        <button
          className="create-btn"
          onClick={() => navigate("/register")}
        >
          Create Account
        </button>

        <button
          className="login-btn"
          onClick={() => navigate("/login")}
        >
          Login
        </button>

        <p className="welcome-footer">
          Trusted by Local Food Lovers ❤️
        </p>

      </div>

    </div>

  );

}

export default Welcome;